// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.image-text {\n    font-size: 20px !important;\n}\n.question {\n    font-size: 1.2em;\n    color: #444444;\n    text-align: center;\n}\n.contact {\n    font-size: 1.4em;\n    color: #444444;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
